import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { map, pluck } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class FbSimpleFormService {
  encriptedData: string;
  constructor(private httpClient: HttpClient) { }

  saveFormBuilderSimpleForm(payload: any) {
    return this.httpClient.post('/vd/formBuilder/createFormData', payload)
      .pipe(
        map((response: ImagilityBaseResponse) => {
          if (response && response.status === 200) {
            return response;
          } else {
            return null;
          }
        })
      );
  }

  getPageFormData(formDataId) {
    return this.httpClient.get(`/vd/formBuilder/formdata/${formDataId}`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getPageFormDataByPageformId(pageFormId) {
    return this.httpClient.get(`/vd/formBuilder/pageForm/${pageFormId}/formdata`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getPageFormByFormDataId(pageFormId, formDataId) {
    return this.httpClient.get(`/vd/formBuilder/pageFormId/${pageFormId}/formData/${formDataId}/postingDetails`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getPageFormDataByApplicantId(id) {
    return this.httpClient.get(`/vd/formBuilder/get/static/${id}/formData`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  } 

  getPageFormDataByEmployeeId(pageFormId, actualEmployeeId, entityId) {
    const url = `/vd/formBuilder/get/form/${pageFormId}/formData/employee/${actualEmployeeId}`;
    const params = entityId ? { entityId: this.toEncrypt(entityId.toString()) } : null;

    return this.httpClient.get(url, { params }).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getDataFromPageFormIdsAndId(currentPageFormId: number, redirectPageFormId: number, rowId: number) {
    return this.httpClient.get(`/vd/formBuilder/${currentPageFormId}/${redirectPageFormId}/${rowId}/formData`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }
  deleteClientUploadedDocs(pageFormId: any) {
    return this.httpClient.delete(`/vd/fb/delete/talentAcq/documents/${pageFormId}`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response && response.status === 200) {
          return response;
        }
      })
    );
  }

  toEncrypt(_data) {
    var pharase = 'c63a423527b24f65'
    var data = _data;
    var key  = CryptoJS.enc.Latin1.parse(pharase);
    var iv   = CryptoJS.enc.Latin1.parse(pharase);  
    var encrypted = CryptoJS.AES.encrypt(
      data,
      key,
      {iv:iv,mode:CryptoJS.mode.CBC,
        padding:CryptoJS.pad.ZeroPadding
    }).toString();

    var e64 = CryptoJS.enc.Base64.parse(encrypted);
    var eHex = e64.toString(CryptoJS.enc.Hex);

   return this.encriptedData = eHex;
  }

}
